import { createContext, useContext, useState } from "react";
import ModalGenerico from "../pages/private/componentesReutilizados.js/ModalGenerico";
import AlertReload from "../pages/private/componentesReutilizados.js/AlertReload";

export const ModalContext = createContext();

export const useModalGenerico = () => useContext(ModalContext);

export const ModalContextProvider = ({ children }) => {

    const [openModalGenerico, setOpenModalGenerico] = useState(false);
    const [mensagem, setMensagem] = useState('');
    //----------------------------------------------
    const [openAlert, setOpenAlert] = useState(false)
    const [mensagemAlert, setMensagemAlert] = useState('');
    const [reload, setReload] = useState(false)
    const [corSucesso, setCorSucesso] = useState(true);

    const mostraAlert = (mensagem, tipo, cor) => {
        setMensagemAlert(mensagem)
        setOpenAlert(true);
        
        if (cor !== 'sucesso') {
            setCorSucesso(false)
        }

        if (tipo === 'reload') {
            setReload(true)
        }
    }

    //fecha o alert e recarrega 
    const handleCloseAlert = () => {
        setOpenAlert(false);
        if (reload) {
            window.location.reload();
        }
    };

    const mostraMensagem = (mensagem, tipo) => {
        setMensagem(mensagem);
        setOpenModalGenerico(true);
        if (tipo === 'reload') {
            setReload(true)
        }
    }

    const fechaModal = () => {
        setOpenModalGenerico(false);
        setMensagem('');
        if (reload) {
            window.location.reload();
        }
    }

    return (
        <ModalContext.Provider value={{ mostraMensagem, fechaModal, mostraAlert }}>
            {children}
            <ModalGenerico open={openModalGenerico} mensagem={mensagem} handleClose={fechaModal} />
            <AlertReload open={openAlert} handleClick={handleCloseAlert} mensagemAlert={mensagemAlert} corAlert={corSucesso} />
        </ModalContext.Provider>
    )
}

export default ModalContext